import styled, { css } from 'styled-components'
import { TransitionGroup, CSSTransition } from "react-transition-group";
import AppPreviewImage from '../images/app-preview.png';

export const SC_FadingWrapper = styled.div.attrs(props => ({
	className: "App Fade",
}))`
`

export const Sc_TransitionWrapper = styled.div.attrs(props => ({
	className: "transition-wrapper",
}))`
	// height: 100%;

	// .fade-enter {
	// 	opacity: 0.01;
	// }

	// .fade-enter.fade-enter-active {
	// 	opacity: 1;
	// 	transition: opacity 300ms ease-in;
	// }

	// .fade-exit {
	// 	opacity: 1;
	// }

	// .fade-exit.fade-exit-active {
	// 	opacity: 0.01;
	// 	transition: opacity 300ms ease-in;
	// }
`

export const Sc_TransitionGroup = styled(TransitionGroup).attrs(props => ({
	className: "transition-group",
}))`
	// height: 100%;
	position: relative;
`

export const Sc_CSSTransition = styled(CSSTransition).attrs(props => ({
	className: "css-transition",
}))`
	// height: 100%;
`

export const Sc_RouteSection = styled.div.attrs(props => ({
	className: "route-section",
}))`
	// position: absolute;
	// width: 100%;
	// top: 0;
	// left: 0;
	// min-height: 100%;
`

export const Sc_LayoutWrapper = styled.div.attrs(props => ({
  	className: 'layout-wrapper'
}))`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	background: white;
`

export const Sc_PageWrapper = styled.div.attrs(props => ({
  	className: 'page-wrapper'
}))`
	flex: 2 0 auto;
	z-index: 1;
	background: ${props => props.background ? props.theme[props.background] : 'transparent'};
`

export const Sc_PlayVideoBtn = styled.a.attrs(props => ({
	className: 'btn btn-light',
	href: "#",
}))`
	height: 60px;
	width: 60px;
	background: ${props => props.background ? props.theme[props.background] : 'transparent'};
	display: flex;
	align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 auto 5px;
    overflow: hidden;
    flex-shrink: 0;
`

export const Sc_AppPreviewImage = styled.div.attrs(props => ({
	className: 'img-responsive',
}))`
	width: 100%;
	max-width: 600px;
	margin: ${props => props.theme.spacers[6]} auto -230px auto;
	background: no-repeat;
	background-position: center center;
	background-size: contain;
	background-image: url(${AppPreviewImage});

	&:after {
		content: "";
		display: block;
		padding-bottom: 100%;
	}
`

export const Sc_IconList = styled.ul.attrs(props => ({
	className: 'list-unstyled'
}))`
	li {
		display: flex;
		align-items: center;
		margin: 0 ${props => props.theme.gridGutterWidth} ${props => props.theme.gridGutterWidth} 0;

		p {
			margin: 0;
		}
	}
`

export const Sc_IconContainer = styled.div.attrs(props => ({
	
}))`
	height: 60px;
	width: 60px;
	background: ${props => props.background ? props.theme[props.background] : 'transparent'};
	border: solid ${props => props.theme.inputBtnBorderWidth} ${props => props.theme.gray200};
	display: flex;
	align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 ${props => props.theme.spacers[3]} 0 0;
    overflow: hidden;
    flex-shrink: 0;

    @media ${props => props.theme.breakpointsMin.sm} {
		margin-right: ${props => props.theme.spacers[4]};
	}
`

export const Sc_DividedList = styled.ul.attrs(props => ({
	className: 'list-unstyled'
}))`
	margin-bottom: ${props => props.theme.spacers[4]};

	li {
		border-bottom: solid 1px ${props => props.theme.cyanAlt};
		padding: ${props => props.theme.spacers[3]} 0;

		&:last-child {
			border-bottom: none;
		}

		p {
			margin: 0;
		}
	}
`

